import type { FC } from 'react'

import type { Props as EntitiesByWeekProps } from './entitiesByWeek'
import EntitiesByWeek from './entitiesByWeek'
import { groupEntitiesByWeek } from './utils'

import { EmptyState } from '@app/components/ui/empty-state'
import Can from '@app/shared/authorization/can'
import CreateEntityButton from '@app/shared/entities/createEntityButton'
import type { Nodes } from '@app/types'

export type Props = Omit<EntitiesByWeekProps, 'week'> & {
  nodeType: Nodes
}

const AggregatedEntities: FC<Props> = ({ entities = [], nodeType, ...rest }) => {
  if (!entities.length) {
    return (
      <EmptyState title="No events yet" description="Add some events and they will show up here.">
        <Can I="create" an="event" passThrough>
          {(allowed) => {
            if (allowed && ['entity'].includes(nodeType)) {
              return <CreateEntityButton text="Create your first one" variant="subtle" size="sm" />
            }

            return null
          }}
        </Can>
      </EmptyState>
    )
  }

  const entitiesByWeek = groupEntitiesByWeek(entities)
  const sortedEntities = Object.keys(entitiesByWeek).reverse()

  return (
    <>
      {sortedEntities.map((week) => (
        <EntitiesByWeek key={week} week={week} entities={entitiesByWeek[week]} {...rest} />
      ))}
    </>
  )
}

export default AggregatedEntities
